/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErpProjectListItemDto,
  GetApiErpImportGetAllProjectsByDepartmentParams,
  GetApiErpImportGetInitialProjectInformationByReferenceParams,
  GetApiErpImportGetInitialProjectInformationParams,
  ProjectDepartmentDto,
  ProjectImportDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiErpImportGetInitialProjectInformation = (
    params?: GetApiErpImportGetInitialProjectInformationParams,
 signal?: AbortSignal
) => {


      return customInstance<ProjectImportDto>(
      {url: `/api/erp-import/GetInitialProjectInformation`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiErpImportGetInitialProjectInformationQueryKey = (params?: GetApiErpImportGetInitialProjectInformationParams,) => {
    return [
    `/api/erp-import/GetInitialProjectInformation`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiErpImportGetInitialProjectInformationQueryOptions = <TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError = ErrorType<unknown>>(params?: GetApiErpImportGetInitialProjectInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiErpImportGetInitialProjectInformationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>> = ({ signal }) => getApiErpImportGetInitialProjectInformation(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiErpImportGetInitialProjectInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>>
export type GetApiErpImportGetInitialProjectInformationQueryError = ErrorType<unknown>


export function useGetApiErpImportGetInitialProjectInformation<TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError = ErrorType<unknown>>(
 params: undefined |  GetApiErpImportGetInitialProjectInformationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetInitialProjectInformation<TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError = ErrorType<unknown>>(
 params?: GetApiErpImportGetInitialProjectInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetInitialProjectInformation<TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError = ErrorType<unknown>>(
 params?: GetApiErpImportGetInitialProjectInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiErpImportGetInitialProjectInformation<TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError = ErrorType<unknown>>(
 params?: GetApiErpImportGetInitialProjectInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiErpImportGetInitialProjectInformationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiErpImportGetInitialProjectInformationByReference = (
    params?: GetApiErpImportGetInitialProjectInformationByReferenceParams,
 signal?: AbortSignal
) => {


      return customInstance<ProjectImportDto>(
      {url: `/api/erp-import/GetInitialProjectInformationByReference`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiErpImportGetInitialProjectInformationByReferenceQueryKey = (params?: GetApiErpImportGetInitialProjectInformationByReferenceParams,) => {
    return [
    `/api/erp-import/GetInitialProjectInformationByReference`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiErpImportGetInitialProjectInformationByReferenceQueryOptions = <TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError = ErrorType<unknown>>(params?: GetApiErpImportGetInitialProjectInformationByReferenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiErpImportGetInitialProjectInformationByReferenceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>> = ({ signal }) => getApiErpImportGetInitialProjectInformationByReference(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiErpImportGetInitialProjectInformationByReferenceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>>
export type GetApiErpImportGetInitialProjectInformationByReferenceQueryError = ErrorType<unknown>


export function useGetApiErpImportGetInitialProjectInformationByReference<TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError = ErrorType<unknown>>(
 params: undefined |  GetApiErpImportGetInitialProjectInformationByReferenceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetInitialProjectInformationByReference<TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError = ErrorType<unknown>>(
 params?: GetApiErpImportGetInitialProjectInformationByReferenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetInitialProjectInformationByReference<TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError = ErrorType<unknown>>(
 params?: GetApiErpImportGetInitialProjectInformationByReferenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiErpImportGetInitialProjectInformationByReference<TData = Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError = ErrorType<unknown>>(
 params?: GetApiErpImportGetInitialProjectInformationByReferenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetInitialProjectInformationByReference>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiErpImportGetInitialProjectInformationByReferenceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiErpImportGetAllProjects = (

 signal?: AbortSignal
) => {


      return customInstance<ErpProjectListItemDto[]>(
      {url: `/api/erp-import/GetAllProjects`, method: 'GET', signal
    },
      );
    }




export const getGetApiErpImportGetAllProjectsQueryKey = () => {
    return [
    `/api/erp-import/GetAllProjects`
    ] as const;
    }


export const getGetApiErpImportGetAllProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiErpImportGetAllProjectsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>> = ({ signal }) => getApiErpImportGetAllProjects(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiErpImportGetAllProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>>
export type GetApiErpImportGetAllProjectsQueryError = ErrorType<unknown>


export function useGetApiErpImportGetAllProjects<TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetAllProjects<TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetAllProjects<TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiErpImportGetAllProjects<TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiErpImportGetAllProjectsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiErpImportGetAllProjectsByDepartment = (
    params?: GetApiErpImportGetAllProjectsByDepartmentParams,
 signal?: AbortSignal
) => {


      return customInstance<ErpProjectListItemDto[]>(
      {url: `/api/erp-import/GetAllProjectsByDepartment`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiErpImportGetAllProjectsByDepartmentQueryKey = (params?: GetApiErpImportGetAllProjectsByDepartmentParams,) => {
    return [
    `/api/erp-import/GetAllProjectsByDepartment`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiErpImportGetAllProjectsByDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError = ErrorType<unknown>>(params?: GetApiErpImportGetAllProjectsByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiErpImportGetAllProjectsByDepartmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>> = ({ signal }) => getApiErpImportGetAllProjectsByDepartment(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiErpImportGetAllProjectsByDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>>
export type GetApiErpImportGetAllProjectsByDepartmentQueryError = ErrorType<unknown>


export function useGetApiErpImportGetAllProjectsByDepartment<TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError = ErrorType<unknown>>(
 params: undefined |  GetApiErpImportGetAllProjectsByDepartmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetAllProjectsByDepartment<TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError = ErrorType<unknown>>(
 params?: GetApiErpImportGetAllProjectsByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetAllProjectsByDepartment<TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError = ErrorType<unknown>>(
 params?: GetApiErpImportGetAllProjectsByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiErpImportGetAllProjectsByDepartment<TData = Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError = ErrorType<unknown>>(
 params?: GetApiErpImportGetAllProjectsByDepartmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllProjectsByDepartment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiErpImportGetAllProjectsByDepartmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiErpImportGetAllDepartments = (

 signal?: AbortSignal
) => {


      return customInstance<ProjectDepartmentDto[]>(
      {url: `/api/erp-import/GetAllDepartments`, method: 'GET', signal
    },
      );
    }




export const getGetApiErpImportGetAllDepartmentsQueryKey = () => {
    return [
    `/api/erp-import/GetAllDepartments`
    ] as const;
    }


export const getGetApiErpImportGetAllDepartmentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiErpImportGetAllDepartmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>> = ({ signal }) => getApiErpImportGetAllDepartments(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiErpImportGetAllDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>>
export type GetApiErpImportGetAllDepartmentsQueryError = ErrorType<unknown>


export function useGetApiErpImportGetAllDepartments<TData = Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetAllDepartments<TData = Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>,
          TError,
          Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiErpImportGetAllDepartments<TData = Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiErpImportGetAllDepartments<TData = Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiErpImportGetAllDepartments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiErpImportGetAllDepartmentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






